var React = require('react');

function WhiteCheckMarkInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"clip-path"},React.createElement("path",{"id":"Clip_2","data-name":"Clip 2","d":"M0,0H16V13H0Z","fill":"none"}))),React.createElement("path",{"id":"Clip_2-2","data-name":"Clip 2","d":"M0,0H16V13H0Z","fill":"none","key":1}),React.createElement("g",{"id":"_001-check_copy_2-2","data-name":"001-check copy 2","clipPath":"url(#clip-path)","key":2},React.createElement("path",{"id":"Fill_1","data-name":"Fill 1","d":"M13.555,0l-8,8.067L2.445,4.932,0,7.4,5.555,13,16,2.466Z","fill":"#fff"}))]);
}

WhiteCheckMarkInline.defaultProps = {"id":"_001-check_copy_2","data-name":"001-check copy 2","width":"16","height":"13","viewBox":"0 0 16 13"};

module.exports = WhiteCheckMarkInline;

WhiteCheckMarkInline.default = WhiteCheckMarkInline;
